import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface LineChartProps {
  days: string[];      // X-axis labels (e.g., ["Mon", "Tue", "Wed"])
  values: number[];    // Y-axis values (e.g., [10, 20, 15])
}

const WeeklyTrend: React.FC<LineChartProps> = ({ days, values }) => {
  const options: ApexOptions = {
    chart: {
      id: "line-chart",
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    xaxis: {
      categories: days,
      // title: { text: "Days" }
    },
    yaxis: {
      // title: { text: "Numbers" }
    },
    stroke: {
      curve: "smooth",
      width: 3
    },
    markers: {
      size: 4
    },
    tooltip: {
      theme: "dark"
    }
  };

  const series = [
    {
      name: "Value",
      data: values
    }
  ];

  return (
    
    <Chart
      options={options}
      series={series}
      type="area"
      height={120}
    />
  );
};

export default WeeklyTrend;
